import { models } from '@kurtosys/ksys-app-template';

export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	token: '96974c7b-19c0-416b-acb1-04ab0b0465da',
	serviceUrl: 'https://api-rel.fundpress.io',
};